import { getTalkJsConversations, joinToConversation } from './api'
import { ROLE_ADMIN, ROLE_CITY_MANAGER } from '../../shared/constants'
import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { getCityById } from './gql'
import { CHAT_TYPE } from './options'

const sliceText = text => {
  const arrText = text.split('')

  if (arrText.length > 23) {
    return `${arrText.slice(0, 23).join('')}...`
  } else {
    return text
  }
}

const findConversationAndJoin = async ({ userId, role, cityId, countryId }) => {
  if (![ROLE_ADMIN, ROLE_CITY_MANAGER].includes(role)) {
    return
  }

  const filter = {
    [role === ROLE_ADMIN ? 'countryId' : 'cityId']:
      role === ROLE_ADMIN ? countryId : cityId,
  }

  const { data: conversations } = await getTalkJsConversations({
    filter,
  })

  if (conversations.length) {
    const conversationIds = conversations.map(({ id }) => id)

    await Promise.all(
      conversationIds.map(async conversationId => {
        return await joinToConversation({
          conversationId,
          userId: userId,
        })
      }),
    )
  }
}

const getCityList = async user => {
  const cityResult = await getCityById(user.cityId)
  const countryId = cityResult.data.city.country.id

  const query = `query ($countryId: ID!) {
    country (id: $countryId) {
      cities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }`
  const result = await callAuthorizedGraphQLEndpoint(query, {
    countryId,
  })
  const res = await result.json()

  const {
    country: { cities },
  } = res.data

  const { cityNames, cityList } = cities.edges.reduce(
    (acc, node) => {
      acc.cityNames.push(node.node.name)
      acc.cityList.push({ name: node.node.name, id: node.node.id })

      return acc
    },
    { cityNames: [], cityList: [] },
  )

  return { cityNames, cityList }
}

const notificationHandler = ({ data, inbox, session, setViewType }) => {
  const type = data.conversation.id.split(':')[0]
  const conversation = data.conversation.id
    ? session.getOrCreateConversation(data.conversation.id)
    : null

  if (type == 'client-oads') {
    setViewType(CHAT_TYPE.CLIENTS_CHAT)
    inbox.select(conversation)
  }
  if (type == 'support' || type == 'group') {
    setViewType(CHAT_TYPE.SINGLE_CHAT)
    inbox.select(conversation)
  }
  if (type == 'missionReport') {
    setViewType(CHAT_TYPE.REPORT_CHAT)
    inbox.select(conversation)
  }
  if (type == '' || type == null || type == undefined) {
    setViewType(CHAT_TYPE.SINGLE_CHAT)
    inbox.select(conversation)
  }
}

export { sliceText, findConversationAndJoin, getCityList, notificationHandler }
